module.exports = __webpack_public_path__ + "static/media/c3po_by_radiusss.126c8554.svg";